const pages = {
  merchantDetails: '/merchants/:id',
  dealDetails: '/deals/:id',
};

export default pages;
